import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import configData from '../../../temp/config';
import DC_Constants from '../DC_Constants';

const Results = (props) => {
    const [show, setShow] = useState(false);
    const { t } = props;
    const diaperPkg = props.diaperCalculatorData.diaperPackages;

    let resultTeaTitleStr = t('DiaperCalculator_TeaEventResultTitle').replace('{totalPackages}', props.diaperCalculatorData.totalPackages);
    let resultTripTitleStr = t('DiaperCalculator_TripEventResultTitle').replace('{totalPackages}', props.diaperCalculatorData.totalPackages);
    const resultTitle = { __html: props.diaperCalcData.eventType === DC_Constants.BABY_SHOWER ? resultTeaTitleStr : resultTripTitleStr };

    const showMainMenu = () => {
        props.showMainMenu();
    }

    const prventEvent = (e) => {
        e.preventDefault();
    }

    const handleShow = () => setShow(true);


    return (
        <>
            <div className="results-block">
                <div className="results-head">
                    <div className="content">
                        <h1 >{t('DiaperCalculator_Recommended')}</h1>
                        <p dangerouslySetInnerHTML={resultTitle}></p>
                    </div>

                    {props.diaperCalcData.eventType === DC_Constants.BABY_SHOWER && <div className="email-friends">
                        <a href="" onClick={prventEvent}>{t('DiaperCalculator_EmailText')}

                        </a>
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                        {/* <img src={`${configData.sitecoreApiHost}${props.componentData.emailLogo.value.src}`} alt="" /> */}
                    </div>}
                </div>
                
                {props.diaperCalcData.eventType === DC_Constants.BABY_SHOWER && <div className="prod-section">
                    <div className="img-block">
                        <div className="img-wrapper">
                            <img src={`${configData.sitecoreApiHost}${props.componentData.backgroundImage.value.src}`} alt="" />
                        </div>
                        <p>  {t('DiaperCalculator_ResultDisclaimer')}</p>
                    </div>
                    <div className="size-chart">
                        <table>
                            <tbody>
                                <tr>
                                    <th>{t('DiaperCalculator_TeaEventResultSizeColumn')}</th>
                                    <th>{t('DiaperCalculator_TeaEventResultUnitsColumn')}</th>
                                    <th>{t('DiaperCalculator_TeaEventResultPackagesColumn')}</th>
                                </tr>
                                {diaperPkg.length > 0 && diaperPkg.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td><p class="result-circle"><strong>{item.sizeCode}</strong></p></td>
                                            <td><p class="result-circle">{item.noOfUnits}</p></td>
                                            <td><p class="result-circle">{item.noOfPackages}</p></td>
                                        </tr>
                                    )
                                })}
                            </tbody></table>
                    </div>
                </div>}
                {isMobile && <div className="recalculate-wrap " onClick={showMainMenu}>
                            <button>{t('DiaperCalculator_Recalculate')}</button>
                </div>}
            </div>
        </>
    )
}

export default withTranslation()(Results);